<template>
  <div>
    <div style="clear:both"></div>
    <div class="hideBars mt-2" v-if="race && race.competitors">
      <v-card v-for="r in getSortedCompetitors(race.competitors)" :key="r.id" class="mb-1" elevation="0"
        color="bmbackground">
        <v-list-item v-if="!r.scratched" class="pa-0">
          <div class="runnerContainer pa-1 py-xl-2">
            <div class="d-flex align-center " :style="$vuetify.breakpoint.xl ? 'flex-basis: 55%;' : 'flex-basis:440px'">
              <RunnerSilk :runner="r" :race="race" />
              <div class="ml-2" style="flex:2">
                <div :class="$vuetify.breakpoint.xl ? 'pa-0 d-flex align-center justify-space-between' : 'pa-0'">
                  <div class="title font-weight-bold ml-xl-2 mr-xl-10"
                    :style="$vuetify.breakpoint.xl ? 'font-size:1.6rem !important' : ''">{{ r.tabNo }}. {{ r.name }}
                    ({{ r.barrier }})</div>
                  <div class="subtitle font-weight-bold">{{ r.jockey }}</div>
                </div>
              </div>
              <div v-if="['FINAL','INTERIM'].includes(race.status)" style="float:right;-webkit-flex: 1;-moz-flex: 1;flex: 1;" class="ml-4">
                <span v-if="getPosition(race, r.tabNo) === 1" class="placingFirst">{{ getPosition(race, r.tabNo)
                }}st</span>
                <span v-else-if="getPosition(race, r.tabNo) === 2" class="placingSecond">{{ getPosition(race, r.tabNo)
                }}nd</span>
                <span v-else-if="getPosition(race, r.tabNo) === 3" class="placingThird">{{ getPosition(race, r.tabNo)
                }}rd</span>
                <span v-else-if="getPosition(race, r.tabNo)" class="placingFourth">{{ getPosition(race, r.tabNo)
                }}th</span>
              </div>
            </div>
            <!-- Start stakes and prices
              -->
            <div class="runnerOddsItem">
              <div v-if="!r.prices">No Prices Available</div>
              <RunnerOdds v-if="r.prices && (race.status !== 'FINAL' && race.status !== 'INTERIM')"
                :winPrice="getWinPrice(r.prices)" :placePrice="getPlacePrice(r.prices)"
                :showPrice="getShowPrice(r.prices)" :runner="r" :race="race" :disabled="selectedRace.status !== 'OPEN'" />
            </div>
          </div>
        </v-list-item>
        <!-- Start Scratched runners
          -->
        <v-list-item class="pt-0" v-else-if="r.scratched" style="height:20px;">
          <div style="width:100%;">
            <v-list-item-content class="pt-0">
              <v-list-item-title class="pt-3"><span class="title font-weight-bold scratchedRunner mr-4">{{ r.tabNo }}.
                  {{ r.name }} </span><span
                  class="subtitle font-weight-bold mb-5 red--text overline">Scratched</span></v-list-item-title>
            </v-list-item-content>
          </div>
        </v-list-item>
      </v-card>
    </div>
    <v-skeleton-loader v-else class="mx-auto" type="article"></v-skeleton-loader>

  </div>
</template>
  
<script>
import RunnerOdds from './RunnerOdds'
import RunnerSilk from './RunnerSilk'
import { mapState, mapGetters, mapActions } from 'vuex'
import { PRICE_DISPLAY } from '../common/constants'

export default {
  data: () => ({
    setPriceDisplay: PRICE_DISPLAY,
    modalItem: null,
    modalPrice: 0.0,
    betType: null,
    code: null,
    loadRunnersPoll: null
  }),
  name: "RunnerPicker",
  computed: {
    ...mapState(['racePrices', 'signedIn', 'priceCode']),
    ...mapGetters(['getVenueName', 'getSelectedRace']),
    selectedRace() {
      return this.getSelectedRace || {}
    },
    // resulted () {
    //   if (this.race.status !== 'FINAL' || this.race.status !== 'INTERIM') return false
    //   return true
    // },
    race() {
      return this.selectedRace
    }
  },
  components: {
    RunnerOdds,
    RunnerSilk
  },
  beforeUpdate() {
    if (this.signedIn === false) {
      this.cancelRunnerUpdate();
    }
  },
  methods: {
    ...mapActions(['setRaceLoading']),
    activeRunners() {
      const competitors = this.race.competitors
      const filteredCompetitors = competitors.filter(c => !c.scratched)
      return filteredCompetitors.length
    },
    getWinPrice(prices) {
      const showDisplay = PRICE_DISPLAY
      const type = showDisplay.find(c => c.display === 'W' && c.venueName === this.getVenueName && c.enable === true)?.type
      return prices.find(p => p?.type === type)?.price || null
    },
    getPlacePrice(prices) {
      const showDisplay = PRICE_DISPLAY
      const amountOfRunners = this.activeRunners()
      const type = showDisplay.find(c => c.display === 'P' && c.venueName === this.getVenueName && c.enable === true && (c.betParams ? amountOfRunners >= c.betParams : true))?.type
      return prices.find(p => p?.type === type)?.price || null
    },
    getShowPrice(prices) {
      const showDisplay = PRICE_DISPLAY
      const amountOfRunners = this.activeRunners()
      const type = showDisplay.find(c => c.display === 'S' && c.venueName === this.getVenueName && c.enable === true && (c.betParams ? amountOfRunners >= c.betParams : true))?.type
      return prices.find(p => p?.type === type)?.price || null
    },
    cancelRunnerUpdate() {
      clearInterval(this.loadRunnersPoll)
      this.loadRunnersPoll = null
    },
    getSortedCompetitors: function (competitors) {
      const filteredCompetitors = competitors.filter(c => !c.scratched)
      const scratched = competitors.filter(c => c.scratched)
      return [...filteredCompetitors, ...scratched]
    },
    getPosition: function (race, tabNo) {
      const finalPosition = race.competitors.find(c => c.tabNo === tabNo)?.finalPosition
      if (finalPosition && finalPosition > 0) {
        return finalPosition
      }
      if (race.results && race.results[0] && race.results[0].positions) {
        const position = race.results[0].positions.find(p => p.tabNo === tabNo)
        if (position) {
          return position.position
        }
      }
      if (race.results && race.results[0] && race.results[0].positions && race.results[0].positions[0].competitor) {
        const position = race.results[0].positions.find(p => p.competitor.tabNo === tabNo)
        if (position) {
          return position.position
        }
      }
      return null
    }
  },
}
</script>
  
<style scoped>
.runnerContainer {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}

.scratchedRunner {
  text-decoration: line-through;
}

.runnerInfoItem {

  order: 1;
}

.runnerOddsItem {
  order: 2;
}

.runnerInfoDiv {
  float: left;
}

.stakeField {
  width: 70px;
}

.placingFirst {
  display: inline-block;
  margin-left: 6px;
  font-weight: bold;
  color: #fff;
  background: #057faf;
  width: 40px;
  text-align: center;
  padding-top: 2px;
  cursor: pointer;
  float: right;
}

.placingSecond {
  display: inline-block;
  margin-left: 6px;
  font-weight: bold;
  color: #fff;
  background: #ec0101;
  width: 40px;
  text-align: center;
  padding-top: 2px;
  cursor: pointer;
  float: right;
}

.placingThird {
  display: inline-block;
  margin-left: 6px;
  font-weight: bold;
  color: #fff;
  background: #00a500;
  width: 40px;
  text-align: center;
  padding-top: 2px;
  cursor: pointer;
  float: right;
}

.placingFourth {
  display: inline-block;
  margin-left: 6px;
  font-weight: bold;
  color: #fff;
  background: #9b9b9b;
  width: 40px;
  text-align: center;
  padding-top: 2px;
  cursor: pointer;
  float: right;
}</style>
  